import { render, staticRenderFns } from "./HostingKvmConsole.vue?vue&type=template&id=4bdb2314&scoped=true&"
import script from "./HostingKvmConsole.vue?vue&type=script&lang=js&"
export * from "./HostingKvmConsole.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmConsole.vue?vue&type=style&index=0&id=4bdb2314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb2314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdb2314')) {
      api.createRecord('4bdb2314', component.options)
    } else {
      api.reload('4bdb2314', component.options)
    }
    module.hot.accept("./HostingKvmConsole.vue?vue&type=template&id=4bdb2314&scoped=true&", function () {
      api.rerender('4bdb2314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmConsole.vue"
export default component.exports